module.exports = __webpack_public_path__ + "img/713.a4721382.png";